import React, { useState } from "react";
import atypJsonData from "../../data/ICAO/atyp.json";

const AircraftType = () => {
  const [atypInput, setAtypInput] = useState("");
  const [manufacturerInput, setManufacturerInput] = useState("");
  const [modelInput, setModelInput] = useState("");
  const [aircraftData, setAircraftData] = useState([]);
  const [error, setError] = useState(null);

  // Function to handle searches by ICAO, manufacturer, or model
  const handleSearch = (e) => {
    if (e.key === "Enter") {
      let results = atypJsonData;

      if (atypInput) {
        results = results.filter((item) => item.icao.includes(atypInput.toUpperCase()));
      }
      if (manufacturerInput) {
        results = results.filter((item) => item.manufacturer.toLowerCase().includes(manufacturerInput.toLowerCase()));
      }
      if (modelInput) {
        results = results.filter((item) => item.model.toLowerCase().includes(modelInput.toLowerCase()));
      }

      if (results.length === 0) {
        setError("No aircraft types found");
      } else {
        setError(null);
      }

      // Parse the aircraft data (like WTC, engine count, etc.)
      const parsedResults = results.map((entry) => {
        const wtcMap = {
          L: "Light",
          M: "Medium",
          H: "Heavy",
          J: "Super",
        };

        const engineTypeMap = {
          P: "Piston",
          T: "Turboprop/Turboshaft",
          J: "Jet",
          E: "Electric",
          R: "Rocket"
        };

        const wtc = wtcMap[entry.code[0]] || "Unknown";
        const engineCount = entry.code[2] || "Unknown";
        const engineType = engineTypeMap[entry.code[3]] || "Unknown";

        return {
          ...entry,
          wtc,
          engineCount,
          engineType,
        };
      });

      setAircraftData(parsedResults);
    }
  };

  return (
    <div className="text-white">
      <div className="flex space-x-4 p-2 bg-gray-400">
        <input
          type="text"
          placeholder="ICAO"
          value={atypInput}
          onChange={(e) => setAtypInput(e.target.value.toUpperCase())}
          onKeyDown={handleSearch}
          maxLength={4}
          className="text-sm pl-2 monospace-font bg-gray-200 text-black border border-gray-600 w-1/5 p-1"
        />
        <input
          type="text"
          placeholder="Manufacturer"
          value={manufacturerInput}
          onChange={(e) => setManufacturerInput(e.target.value)}
          onKeyDown={handleSearch}
          className="text-sm pl-2 monospace-font bg-gray-200 text-black border border-gray-600 w-2/5 p-1"
        />
        <input
          type="text"
          placeholder="Model"
          value={modelInput}
          onChange={(e) => setModelInput(e.target.value)}
          onKeyDown={handleSearch}
          className="text-sm pl-2 monospace-font bg-gray-200 text-black border border-gray-600 w-2/5 p-1"
        />
      </div>

      {/* Error message */}
      {error && <div className="p-2 text-red-500">{error}</div>}

      {/* Aircraft data table */}
      {aircraftData.length > 0 && (
        <div className="table-container text-sm overflow-x-auto p-0">
          <table className="min-w-full table-auto border-collapse w-full">
            <thead>
              <tr className="bg-gray-400">
                <th className="p-2 text-left">ICAO</th>
                <th className="p-2 text-left">Manufacturer</th>
                <th className="p-2 text-left">Model</th>
                <th className="p-2 text-left">WTC</th>
                <th className="p-2 text-left">Engines</th>
              </tr>
            </thead>
            <tbody className="text-black">
              {aircraftData.map((aircraft, index) => (
                <tr
                  key={index}
                  className={`bg-gray-100 ${index % 2 === 0 ? "bg-gray-200" : ""}`}
                >
                  <td className="p-2 border text-left">{aircraft.icao}</td>
                  <td className="p-2 border text-left">{aircraft.manufacturer}</td>
                  <td className="p-2 border text-left">{aircraft.model}</td>
                  <td className="p-2 border text-left">{aircraft.wtc} ({aircraft.code[0]})</td>
                  <td className="p-2 border text-left">{aircraft.engineCount} {aircraft.engineType}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AircraftType;
